import angular from 'angular';

angular.module('cloudX').directive('cxCountry', [
  '$filter',
  '$rootScope',
  'dataCache',
  function($filter, $rootScope, dataCache) {
    return {
      restrict: 'E',
      template:
        '<select ng-model="model" class="form-control" ng-change="setValue(model)"> ' +
        '<option value="" ng-hide="model">- {{\'Choose\'|translate}} -</option> ' +
        '<option ng-selected="{{country.id == model}}" value="{{country.id}}" ng-repeat="country in countries | filter:(showAll?{}:{common:true}) | orderBy:\'label\'">{{country.label}}</option>' +
        '<option ng-hide="showAll" value="SHOWALL" data-translate>Show all</option>' +
        '</select>',
      require: 'ngModel',
      link: function($scope, el, attrs, ngModel) {
        if (!ngModel) return;

        var options = dataCache.getArray('country');
        $scope.showAll = false;
        var mapOptions = function() {
          $scope.countries = options.map(function(c) {
            return {
              id: c.code,
              label: $filter('translateList')(c.code, 'country', c.name),
              common: c.isCommon,
            };
          });
        };

        mapOptions();
        var deregistration = $rootScope.$on('$translateChangeSuccess', mapOptions);
        $scope.$on('$destroy', deregistration);

        $scope.setValue = function(value) {
          if (value === 'SHOWALL') {
            $scope.showAll = true;
            $scope.model = ngModel.$viewValue;
            return;
          }
          ngModel.$setViewValue(value);
        };

        ngModel.$render = function() {
          $scope.model = ngModel.$viewValue;
        };
      },
    };
  },
]);
